import { LABEL_PERMISSION_DEFAULTS, UserRole, type IUserPermission } from "@speakai/shared";

/** A permission with every group present, as the permission editors hold it */
export type FullPermission = Required<IUserPermission>;

export type PermissionGroup = keyof Omit<FullPermission, "role">;

export function createDefaultPermission(role: UserRole): FullPermission {
  if (role === UserRole.ADMIN) {
    return {
      role: UserRole.ADMIN,
      folder: { create: true, delete: true, download: true, share: true, assign: true, accessAll: true },
      recorder: { create: true, edit: true, delete: true, download: true, accessAll: true },
      media: { edit: true, delete: true, download: true, share: true },
      payment: { manageCards: true, manageInvoices: true },
      teamManagement: { manageMembers: true, manageGroups: true },
      developer: { accessKeys: false },
      meetingAssistant: { customizeAssistant: true, shareMeetings: true, routeMeetings: true, excludeMeetings: true, globalSettings: true },
      profileSettings: { accountPreferences: true, accountCustomization: true, dataManagement: true },
      labels: { ...LABEL_PERMISSION_DEFAULTS[UserRole.ADMIN].labels },
      comments: { ...LABEL_PERMISSION_DEFAULTS[UserRole.ADMIN].comments },
    };
  }
  return {
    role: UserRole.MEMBER,
    folder: { create: true, delete: false, download: true, share: false, assign: false, accessAll: false },
    recorder: { create: true, edit: false, delete: false, download: true, accessAll: false },
    media: { edit: false, delete: false, download: true, share: true },
    payment: { manageCards: false, manageInvoices: false },
    teamManagement: { manageMembers: false, manageGroups: false },
    developer: { accessKeys: false },
    meetingAssistant: { customizeAssistant: false, shareMeetings: false, routeMeetings: false, excludeMeetings: false, globalSettings: false },
    profileSettings: { accountPreferences: false, accountCustomization: false, dataManagement: false },
    labels: { ...LABEL_PERMISSION_DEFAULTS[UserRole.MEMBER].labels },
    comments: { ...LABEL_PERMISSION_DEFAULTS[UserRole.MEMBER].comments },
  };
}
